import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import {
  Truck, ShieldAlert, PackageCheck, Hourglass, PackageOpen, ArrowRight,
} from "lucide-react";
import api from "./api";

/* Console (Management Portal) Dashboard , operational fulfilment only.
   Strict separation from /admin , no catalogue, audit, customers admin,
   or order-create shortcuts. Just the 5-stage pipeline at a glance. */

const AUTUMN = "/photos/brand/seasons/autumn.webp";

const PIPELINE = [
  { key: "awaiting_payment", label: "Awaiting Payment", Icon: Hourglass,    href: "/console/orders/awaiting_payment" },
  { key: "assigned",         label: "Packing",          Icon: PackageOpen,  href: "/console/orders/packing" },
  { key: "shipping",         label: "Shipping",         Icon: Truck,        href: "/console/orders/shipping" },
  { key: "quality_control",  label: "Quality Control",  Icon: ShieldAlert,  href: "/console/orders/qc" },
  { key: "completed",        label: "Completed",        Icon: PackageCheck, href: "/console/orders/completed" },
];

const AUBERGINE = "#3E1F46";
const PLUM = "#5B2A4F";
const GOLD = "#C9A268";
const CREAM = "#FBF6E9";
const PARCH_EDGE = "#E8DFCB";

export default function ConsoleDashboard() {
  const [counts, setCounts] = useState({});
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        const r = await api.get("/console/dashboard");
        setCounts(r.data || {});
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div data-testid="console-dashboard" className="space-y-8">
      <header
        className="relative overflow-hidden rounded-md border"
        style={{ borderColor: PARCH_EDGE }}
      >
        <div
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: `url(${AUTUMN})`, opacity: 0.35 }}
          aria-hidden
        />
        <div className="absolute inset-0" style={{ background: `linear-gradient(90deg, ${CREAM}EE 0%, ${CREAM}99 60%, transparent 100%)` }} aria-hidden />
        <div className="relative px-7 py-8">
          <div className="text-[10px] tracking-[0.5em] uppercase font-semibold" style={{ color: PLUM }}>
            ✦ Heritage Dahlias · Management ✦
          </div>
          <h1 className="font-serif text-5xl mt-2 leading-tight" style={{ color: AUBERGINE, letterSpacing: "0.01em" }}>
            My Dashboard
          </h1>
          <p className="font-serif italic text-[#6E5849] mt-2 max-w-2xl text-base">
            Pack, ship, deliver. Click any stage to open the live list.
          </p>
        </div>
      </header>

      <section>
        <div className="mb-3">
          <div className="text-[9px] tracking-[0.45em] uppercase font-semibold" style={{ color: PLUM }}>
            ✦ Order pipeline
          </div>
          <h2 className="font-serif text-2xl mt-0.5" style={{ color: AUBERGINE, letterSpacing: "0.01em" }}>
            By stage
          </h2>
        </div>
        <div className="grid grid-cols-2 md:grid-cols-5 gap-3">
          {PIPELINE.map((c) => {
            const value = loading ? "…" : (counts[c.key] ?? 0);
            return (
              <Link
                key={c.key}
                to={c.href}
                data-testid={`console-stat-${c.key}`}
                className="group relative overflow-hidden rounded-md border bg-white p-4 hover:shadow-lg transition-shadow"
                style={{ borderColor: PARCH_EDGE }}
              >
                <div className="flex items-center justify-between mb-1.5">
                  <c.Icon className="w-5 h-5" style={{ color: PLUM }} />
                  <ArrowRight className="w-4 h-4 opacity-0 group-hover:opacity-70 transition" style={{ color: PLUM }} />
                </div>
                <div className="text-[9px] tracking-[0.32em] uppercase font-semibold" style={{ color: "#7A6A55" }}>
                  {c.label}
                </div>
                <div className="font-serif text-4xl mt-1 leading-none" style={{ color: AUBERGINE }}>
                  {value}
                </div>
                <div className="mt-2 h-0.5 w-8 transition-all group-hover:w-16" style={{ backgroundColor: GOLD }} />
              </Link>
            );
          })}
        </div>
      </section>
    </div>
  );
}
